export default __webpack_public_path__ + "static/media/wallofshame.3ab65868.png";